/**
 * Guard against intermittent removal / failed application of Shopify's compiled
 * stylesheet (generated from `{% stylesheet %}` blocks).
 *
 * When that stylesheet is missing, sections that rely on it (like header and product
 * information) can appear "unstyled" even though `base.css` is loaded.
 */
(function ensureCompiledStylesheetPresent() {
  const SELECTOR = 'link[rel="stylesheet"][href*="/compiled_assets/styles.css"]';
  const existing = document.head.querySelector(SELECTOR);

  // If the theme doesn't generate compiled styles (or Shopify changed markup), no-op.
  if (!existing) return;

  const initialHref = existing.getAttribute('href') || existing.href;
  const initialAttrs = {};
  for (const attr of Array.from(existing.attributes)) {
    initialAttrs[attr.name] = attr.value;
  }

  let didRetry = false;

  function createLink(href) {
    const link = document.createElement('link');
    for (const [name, value] of Object.entries(initialAttrs)) {
      // Avoid copying potentially stale href; we set it explicitly below.
      if (name.toLowerCase() === 'href') continue;
      link.setAttribute(name, value);
    }
    link.setAttribute('rel', 'stylesheet');
    if (initialAttrs.media) link.setAttribute('media', initialAttrs.media);
    link.setAttribute('href', href);
    link.addEventListener(
      'error',
      () => {
        if (didRetry) return;
        didRetry = true;
        const cacheBust = (href.includes('?') ? '&' : '?') + 'cb=' + Date.now();
        link.setAttribute('href', href + cacheBust);
      },
      { once: true }
    );
    return link;
  }

  function ensure() {
    if (document.head.querySelector(SELECTOR)) return;
    document.head.appendChild(createLink(initialHref));
  }

  // Re-check after bfcache restores, view transitions, or any head mutations.
  window.addEventListener('pageshow', ensure);
  window.addEventListener('pagereveal', ensure);

  const observer = new MutationObserver(() => ensure());
  observer.observe(document.head, { childList: true });

  // In case the link is removed extremely early, re-add ASAP.
  ensure();
})();

